module.exports = __webpack_public_path__ + "static/media/pin-d.ef122d78.svg";